import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth,  } from 'aws-amplify';
import { RootState } from '../../store/store';
import { Loading, sessionUpdated } from '../../App/app';
import { hgsKeyBackendUri } from '../../uris';

interface RelevantApp {
  name: string,
  isRelevantForDashboard: boolean,
}

export interface DashboardState {
  loading: Loading,
  relevantApps: RelevantApp[],
  currentRequestId: string,
  error: SerializedError | null,
}

const initialState: DashboardState = {
  loading: 'idle',
  relevantApps: [],
  currentRequestId: '',
  error: null,
}


export const fetchRelevantApps = createAsyncThunk(
  'dashboard/fetchRelevantApps',
  async ( _, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.dashboard;

    if ( loading !== 'pending' || thunkAPI.requestId !== currentRequestId ) return;

    return Auth.currentAuthenticatedUser().then( cognitoUser => {

      thunkAPI.dispatch(sessionUpdated({
        accessToken: cognitoUser.signInUserSession.accessToken.jwtToken,
        refreshToken: cognitoUser.signInUserSession.refreshToken.token,
        idToken: cognitoUser.signInUserSession.idToken.jwtToken
      }));

      const state = thunkAPI.getState() as RootState;

      return fetch(`${ hgsKeyBackendUri }/hgsKeyRelevantApps`, {
        method: 'GET',
        headers: {
          "Authorization": state.app.session.idToken,
          "Content-Type": "text/plain",
        },
      }
    ).then( response => {

      if( !response.ok ) throw Error( 'Failed to fetch relevant apps' );
      return response.json();
    }).then( relevantApps => {
      thunkAPI.dispatch( relevantAppsUpdated( relevantApps ) );
    });
    });
  }
)

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    relevantAppsUpdated: ( state, action: PayloadAction<RelevantApp[]> ) => {

      state.loading = 'succeeded';
      state.relevantApps = action.payload
      // Filter Apps which are only relevant for the dashboard
        .filter( app => app.isRelevantForDashboard );
    },
  },
  extraReducers: ( builder ) => {
      builder.addCase(fetchRelevantApps.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase(fetchRelevantApps.fulfilled, (state, action) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          state.currentRequestId = ''
        }
      })
      .addCase(fetchRelevantApps.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if (
          state.loading === 'pending' &&
          state.currentRequestId === requestId
        ) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const { relevantAppsUpdated, } = dashboardSlice.actions

export default dashboardSlice.reducer
